import { TranscriptStatus } from '../../entities/transcripts/transcript';

export interface StatusInfo {
  icon: string;
  label: string;
  tooltip?: string;
}

export const STATUS_MAP = new Map<TranscriptStatus, StatusInfo>([
  [
    TranscriptStatus.TRANSCRIPT_GENERATING,
    {
      icon: 'transcripts',
      label: `status.${TranscriptStatus.TRANSCRIPT_GENERATING}`,
    },
  ],
  [
    TranscriptStatus.TRANSCRIPT_GENERATION_FAILED,
    {
      icon: 'error',
      label: `status.${TranscriptStatus.TRANSCRIPT_GENERATION_FAILED}`,
      tooltip: `status_tooltip.${TranscriptStatus.TRANSCRIPT_GENERATION_FAILED}`,
    },
  ],
  [
    TranscriptStatus.EMAIL_FAILED,
    {
      icon: 'error',
      label: `status.${TranscriptStatus.EMAIL_FAILED}`,
      tooltip: `status_tooltip.${TranscriptStatus.EMAIL_FAILED}`,
    },
  ],
  [
    TranscriptStatus.TRANSCRIPT_GENERATED,
    {
      icon: 'transcripts',
      label: `status.${TranscriptStatus.TRANSCRIPT_GENERATED}`,
    },
  ],
  [
    TranscriptStatus.EMAIL_SENT,
    {
      icon: 'mail1',
      label: `status.${TranscriptStatus.EMAIL_SENT}`,
    },
  ],
  [
    TranscriptStatus.EMAIL_OPENED,
    {
      icon: 'mail-open',
      label: `status.${TranscriptStatus.EMAIL_OPENED}`,
    },
  ],
  [
    TranscriptStatus.EMAIL_BOUNCED,
    {
      icon: 'warning',
      label: `status.${TranscriptStatus.EMAIL_BOUNCED}`,
      tooltip: `status_tooltip.${TranscriptStatus.EMAIL_BOUNCED}`,
    },
  ],
  [
    TranscriptStatus.EMAIL_RECEIVED,
    {
      icon: 'mail1',
      label: `status.${TranscriptStatus.EMAIL_RECEIVED}`,
    },
  ],
  [
    TranscriptStatus.EMAIL_DROPPED,
    {
      icon: 'warning',
      label: `status.${TranscriptStatus.EMAIL_DROPPED}`,
      tooltip: `status_tooltip.${TranscriptStatus.EMAIL_DROPPED}`,
    },
  ],
  [
    TranscriptStatus.TRANSCRIPT_VIEWED,
    {
      icon: 'view1',
      label: `status.${TranscriptStatus.TRANSCRIPT_VIEWED}`,
    },
  ],
]);
